import styled from 'styled-components';

export const Container = styled.div`
  .wrapper {
    display: flex;
    flex-direction: column;
    padding: 2rem 3rem;
    height: 100vh;
  }
`

export const SearchBarContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr min-content;
  column-gap: 1rem;
`

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height:100%;
  max-height: 100%;
  overflow-y: auto;
  padding: 1rem 0;
  margin-top: 2rem;
`

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50vh;

  p {
    margin-top: 0.5rem;
    font-family: DM Sans;
    font-size: 1.3rem;
  }

  span {
    font-family: Inter;
    color: var(--grey-100);
  }

  @media (max-width: 1366px) {
    p {
      font-size: 1.2rem;
    }

    span {
      font-size: 0.9rem;
    }
  }
`